import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	burnupReportTitle: {
		id: 'software-reports-report-page.header.burnup-report-title',
		defaultMessage: 'Burnup report',
		description: 'The page heading title for the Burnup report page.',
	},
	velocityReportTitle: {
		id: 'software-reports-report-page.header.velocity-report-title',
		defaultMessage: 'Velocity report',
		description: 'The page heading title for the Velocity report page.',
	},
	cumulativeFlowTitle: {
		id: 'software-reports-report-page.header.cumulative-flow-title',
		defaultMessage: 'Cumulative flow diagram',
		description: 'The page heading title for the Cumulative Flow Diagram page.',
	},
	burndownTitle: {
		id: 'software-reports-report-page.header.burndown-title',
		defaultMessage: 'Sprint burndown chart',
		description: 'The page heading title for the sprint burndown chart page.',
	},
	hideHowToRead: {
		id: 'software-reports-report-page.header.hide-how-to-read',
		defaultMessage: 'Hide report help',
		description: 'Clickable text to hide the section describing how to read the current report',
	},
	beta: {
		id: 'software-reports-report-page.header.beta',
		defaultMessage: 'Beta',
		description: 'A label indicating the current page is in Beta',
	},
});
